import React, { useMemo } from 'react';
import { AvatarIcon } from '../../../components/icons/AvatarIcon';
import { LocationIcon } from '../../../components/icons/LocationIcon';
import { Box } from '../../../components/UI-CHAKRA/Box';
import { Flex } from '../../../components/UI-CHAKRA/Flex';
import { Text } from '../../../components/UI-CHAKRA/Text';
import { Establishment } from '../../../interfaces/establishment';

export interface PatientEstablishmentCardProps {
  patientName?: string;
  establishment?: Establishment;
}

export function buildEstablishmentLabel(establishment?: Establishment): string {
  if (!establishment) return '';

  const address = establishment.Endereco;
  const addressParts = [
    [address?.Endereco1, address?.Numero].filter(Boolean).join(', '),
    address?.Bairro,
  ].filter(Boolean);

  return [establishment.Nome, ...addressParts].filter(Boolean).join(' - ');
}

export function PatientEstablishmentCard({ patientName, establishment }: PatientEstablishmentCardProps) {
  const establishmentName = useMemo(() => buildEstablishmentLabel(establishment), [establishment]);

  return (
    <Flex
      mb={'20px'}
      w={'100%'}
      maxW={{ base: '100%', md: '1000px' }}
      flexDirection={{ base: 'column', md: 'row' }}
      alignItems={{ base: 'stretch', md: 'stretch' }}
      overflow={'hidden'}
      borderRadius={'16px'}
      border={'1px solid #E9ECEF'}
      bg={'white'}
    >
      <Flex flex={1} alignItems={'center'} gap={'12px'} py={'12px'} px={'16px'}>
        <Flex
          w={'36px'}
          h={'36px'}
          flexShrink={0}
          alignItems={'center'}
          justifyContent={'center'}
          borderRadius={'8px'}
          bg={'#F1EFF9'}
          color={'primary.main'}
        >
          <AvatarIcon size={18} />
        </Flex>
        <Box>
          <Text fontSize={'14px'} color={'gray.800'}>
            Paciente
          </Text>
          <Text fontSize={'14px'} fontWeight={'bold'} color={'gray.800'}>
            {patientName}
          </Text>
        </Box>
      </Flex>

      <Box
        w={{ base: '100%', md: '1px' }}
        h={{ base: '1px', md: 'auto' }}
        my={{ base: 0, md: '12px' }}
        bg={'#E9ECEF'}
      />

      <Flex flex={2} alignItems={'center'} gap={'12px'} py={'12px'} px={'16px'}>
        <Flex
          w={'36px'}
          h={'36px'}
          flexShrink={0}
          alignItems={'center'}
          justifyContent={'center'}
          borderRadius={'8px'}
          bg={'#F1EFF9'}
          color={'primary.main'}
        >
          <LocationIcon size={18} />
        </Flex>
        <Box>
          <Text fontSize={'14px'} color={'gray.800'}>
            Local de atendimento
          </Text>
          <Text fontSize={'14px'} fontWeight={'bold'} color={'gray.800'}>
            {establishmentName}
          </Text>
        </Box>
      </Flex>
    </Flex>
  );
}
